import { HttpClient } from './httpClient'

export const generatePgaGuid = () => {
  try {
    if (typeof crypto !== "undefined" && crypto.getRandomValues) {
      const bytes = new Uint8Array(16);
      crypto.getRandomValues(bytes);
      return Array.from(bytes, (byte) => byte.toString(16).padStart(2, "0")).join("").toUpperCase();
    }
  } catch (e) {}
  return (Date.now().toString(16) + Math.random().toString(16).slice(2)).slice(0, 32).toUpperCase();
};

export const calculateCheckDigit = (filerCode, entryNumber) => {
  let data = {
    eventType: 'CALCULATE_CHECK_DIGIT',
    eventTime: Date.now(),
    eventMessage: `${filerCode},${entryNumber}`
  }
  console.log('CALCULATE_CHECK_DIGIT', data)
  return HttpClient.post(data)
}

export const transformTransactionsForMerge = (data = {}) =>{
  const shipment = data?.transactionList?.map((transaction)=>({
    state:{
      shipmentId: transaction.transactionId,
      mbol: transaction?.mblList,
      hbol: transaction?.hblList,
      countryOfOrigin: transaction?.exportCountry,
      unlocUnlading: transaction?.portOfUnlading,
      carrierName: transaction?.vesselName,
      modeOfTransport: transaction?.modeOfTransport
    }
  }))
  return {
    shipment
  }
}
export const isTargetApp  = () => {
  const url = window.location.href
  return url.includes('target')
}